module.exports = __webpack_public_path__ + "46f669a340f83dcf4f05e6f56035976e.svg";